import { render } from "./ModalHeader.vue?vue&type=template&id=3cd82bad&scoped=true"
import script from "./ModalHeader.vue?vue&type=script&lang=js"
export * from "./ModalHeader.vue?vue&type=script&lang=js"

import "./ModalHeader.vue?vue&type=style&index=0&id=3cd82bad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd82bad"]])

export default __exports__